<template>
    <div class="chat-wrapper">

        <!-- Message Area -->
        <div id="appCapsule" class="chat-body" ref="chatBody">

            <!-- Loading -->
            <div class="chat-status" v-if="loading">
                <span>Loading messages…</span>
            </div>

            <!-- Empty -->
            <div class="chat-status" v-else-if="messages.length === 0">
                <ion-icon name="chatbubbles-outline" style="font-size:36px; margin-bottom:8px;"></ion-icon>
                <span>No messages yet</span>
            </div>

            <!-- Messages -->
            <template v-for="(message, idx) in messages">

                <!-- Received (user) -->
                <div class="msg-row received" :key="'msg_'+idx" v-if="!message.data.from_admin">
                    <div class="msg-avatar">{{ senderInitial(message) }}</div>
                    <div class="msg-group">
                        <div class="msg-name">{{ message.data.from }}</div>
                        <div class="msg-bubble received-bubble">{{ message.data.content }}</div>
                        <div class="msg-time">{{ getReadableDatetime(message.data.created_at) }}</div>
                    </div>
                </div>

                <!-- Sent (admin) -->
                <div class="msg-row sent" :key="'msg_admin_'+idx" v-else>
                    <div class="msg-group">
                        <div class="msg-bubble sent-bubble">{{ message.data.content }}</div>
                        <div class="msg-time text-end">{{ getReadableTime(message.data.created_at) }}</div>
                    </div>
                </div>

            </template>
        </div>

        <!-- Input Footer -->
        <support-message />
    </div>
</template>

<script>
import supportMessage from "../../../components/admin/supportMessage";
import methodsMixin from "../../../utils/methodsMixin";
import {supports_store} from "../../../configs/firebase";

export default {
    name: "Support",
    data(){
        return {
            messages: [],
            loading: false,
            listener: null,
            headerName: 'User',
        }
    },
    mixins: [methodsMixin],
    computed: {
        headerInitial(){
            return this.headerName.charAt(0).toUpperCase();
        }
    },
    methods: {
        senderInitial(message){
            const name = message.data.from || '';
            return name.charAt(0).toUpperCase() || '?';
        },
        async fetchConversations(){
            this.loading = true;
            const userId = this.$route.params.userId;
            try {
                const userRes = await this.$store.dispatch('user/getUser', userId);
                if (userRes && userRes.data && userRes.data.data) {
                    this.headerName = userRes.data.data.name || 'User';
                    this.$emit('set-chat-title', this.headerName);
                }
                this.listener = supports_store
                    .doc(userId)
                    .collection('messages')
                    .orderBy('created_at')
                    .onSnapshot(async (snapshot) => {
                        let tmp = [];
                        snapshot.forEach(doc => tmp.push({ id: doc.id, data: doc.data() }));
                        this.messages = tmp;
                        this.$nextTick(() => {
                            const el = this.$refs.chatBody;
                            if (el) el.scrollTop = el.scrollHeight;
                        });
                        await this.$store.dispatch('support/markMsgAsRead', userId);
                    });
            } catch(e) {
                console.log(e);
            }
            this.loading = false;
        }
    },
    components: { supportMessage },
    mounted() {
        this.fetchConversations();
    },
    beforeRouteLeave(to, from, next){
        if (this.listener) this.listener();
        next();
    }
}
</script>

<style scoped>
/* Layout */
.chat-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: var(--color-bg, #F8FAFC);
}


/* Body — bottom = input bar (~70px) + bottom nav (~56px) + safe margin */
.chat-body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 16px 14px 160px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* Status */
.chat-status {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--color-muted, #64748B);
    font-size: 13px;
    text-align: center;
    padding: 60px 0;
}

/* Message rows */
.msg-row {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    max-width: 100%;
}
.msg-row.sent {
    flex-direction: row-reverse;
}
.msg-row.received {
    flex-direction: row;
}

/* Avatar for received */
.msg-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--color-border, #E2E8F0);
    color: var(--color-text, #0F172A);
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

/* Group */
.msg-group {
    display: flex;
    flex-direction: column;
    max-width: 72%;
}
.msg-name {
    font-size: 10px;
    font-weight: 600;
    color: var(--color-muted, #64748B);
    margin-bottom: 3px;
    padding-left: 2px;
}

/* Bubbles */
.msg-bubble {
    padding: 10px 14px;
    border-radius: 18px;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;
}
.received-bubble {
    background: #fff;
    color: var(--color-text, #0F172A);
    border: 1px solid var(--color-border, #E2E8F0);
    border-bottom-left-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}
.sent-bubble {
    background: var(--theme-primary-500, #10B981);
    color: #fff;
    border-bottom-right-radius: 4px;
    box-shadow: 0 2px 6px rgba(16,185,129,0.3);
}

/* Timestamps */
.msg-time {
    font-size: 10px;
    color: var(--color-muted, #64748B);
    margin-top: 3px;
    padding: 0 2px;
}
</style>
